import { lazy, Suspense } from "react";
import { Routes, Route } from "react-router-dom";
import { base } from "../globals/route-names";

const PublicUserLayout = lazy(() => import("../layouts/public-user-layout"));

function AppRoutes() {
    return (
        <Suspense fallback={null}>
            <Routes>
                <Route path={base.PUBLIC_PRE + "/*"} element={<PublicUserLayout />} />
            </Routes>
        </Suspense>
    );
}

export default AppRoutes;
